export const state = {
  signingViewPending: false,
  signingView: null,
  signingViewError: null,
  ndaSigningViewPending: false,
  ndaSigningViewError: null,
}
